module.exports = __webpack_public_path__ + "static/media/search_slider_phone1.77da84fc.png";